import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import PickerDialog from "./PickerDialog";
import { Box, InputAdornment, TextField } from "@mui/material";

export const ColorPicker = ({
    // ColorPicker
    onChange,
    name,
    id,
    hintText,
    placeholder,
    floatingLabelText,
    label,
    TextFieldProps,
    value,
    color,
    internalValue,
    setValue,
    error,
    allowEdit,
    onBlur,
    ...custom
}: any) => {
    const [showPicker, setShowPicker] = useState(false);
    const [colorHex, setColor] = useState("");

    useEffect(() => {
        setColor(color);
    }, [color]);

    return (
        <>
            <TextField
                name={name}
                id={id}
                size="small"
                fullWidth
                label={"Background color"}
                placeholder={hintText || placeholder}
                value={colorHex}
                variant="outlined"
                onClick={() => setShowPicker(true)}
                onChange={(e) => {
                    const value = e.target.value;
                    onChange(value);
                    setColor(value);
                }}
                helperText={error || ""}
                error={error && true}
                onBlur={onBlur}
                disabled={!allowEdit}
                InputProps={{
                    style: {
                        backgroundColor: !allowEdit ? "#e0e0e0" : "inherit",
                    },
                    endAdornment: (
                        <InputAdornment position="end">
                            {allowEdit && (
                                <Box
                                    style={{
                                        backgroundColor: colorHex || "#000",
                                        width: "20px",
                                        height: "20px",
                                        marginRight: "8px", // Adjust spacing as needed
                                    }}
                                />
                            )}
                        </InputAdornment>
                    ),
                }}
            />
            {showPicker && allowEdit && (
                <PickerDialog
                    value={colorHex}
                    onClick={() => {
                        setShowPicker(false);
                        onChange(value);
                    }}
                    onChange={(c) => {
                        if (c?.hex) {
                            onChange(c.hex);
                            setColor(c.hex);
                        }
                    }}
                />
            )}
        </>
    );
};
